import { MultiSelect, MultiSelectPanelHeaderTemplateParams } from 'primereact/multiselect';
import { DropdownOption } from './Dropdown';

function MultiDropdown(props: {
    value: (string | number)[];
    options: DropdownOption[];
    onChange: (values: any[]) => void;
    placeholder: string;
    disabled?: boolean;
    filterPlaceholder?: string;
    className?: string;
}) {
    const { value, options, onChange, placeholder, disabled, filterPlaceholder, className } = props;

    const panelHeader = (e: MultiSelectPanelHeaderTemplateParams) => (
        <div className={`${e.className} dbm-multiselect-header`}>
            <label className="dbm-multiselect-select-all">
                {e.checkboxElement}
                <span>Select all</span>
            </label>
            {e.filterElement}
            {e.closeElement}
        </div>
    );

    return (
        <MultiSelect
            value={value}
            options={options}
            onChange={(e) => onChange(e.value)}
            placeholder={placeholder}
            display="chip"
            filter
            filterPlaceholder={filterPlaceholder ?? 'Search'}
            emptyFilterMessage="No matches"
            scrollHeight="260px"
            panelHeaderTemplate={panelHeader}
            className={['w-100', 'dbm-multiselect', className].filter(Boolean).join(' ')}
            panelClassName="dbm-multiselect-panel"
            disabled={disabled}
        />
    );
}

export default MultiDropdown;
